import { connect } from "react-redux";
import { ApplicationState } from "../../../store";
import { bindActionCreators, Dispatch } from "redux";

import Dashboard from "../../../../ui/mui/Dashboard";
import { AninharView, menuRotas } from "../../../services/router";
import { db } from "../../../services/db";
import { useEffect, useState } from "react";
import { PageDegrade } from "../../../../ui/mui/PageDegrade";
import { Button, CircularProgress, Skeleton, Stack, Typography } from "@mui/material";

import { configController } from "../../config/config.controll";
import { ConfigActions, ConfigState } from "../../config/config.model";
import { TipoMovActions, TipoMovState } from "../../tipoMov/tipomov.model";
import { tipoMovController } from "../../tipoMov/tipomov.controll";
import Alerts from "../../../components/alerts/Alerts";
import { MovActions, MovState } from "../../movimentacoes/mov.model";
import { movController } from "../../movimentacoes/mov.controll";
import { CanalDistribuicaoActions } from "../../canalDist/canalDist.model";
import { canalDistController } from "../../canalDist/canalDist.controll";
import { Funcionario, FuncionarioActions, FuncionarioState } from "../../funcionario/funcionario.model";
import SelecionarFuncionario from "../../funcionario/view/funcionario.select"
import { funcionarioController } from "../../funcionario/funcionario.controll";
import { Login } from "@mui/icons-material";


interface RootViewProps {
    configActions: ConfigActions
    configState: ConfigState
    tipoMovActions: TipoMovActions
    tipoMovState: TipoMovState
    movState: MovState
    movActions: MovActions
    canalDistribuicaoActions: CanalDistribuicaoActions
    funcionarioState: FuncionarioState
    funcionarioActions: FuncionarioActions
}
/**
 * status app: pode esta em 3 situacoes
 * iniciando: enquanto os dados estao sendo replicado
 * logando: verificando se ja tem funcionario logado, se nao apresentar a tela de selecionar funcionario
 * 
 * pronto: tudo pronto para usar o aplicativo
 */
interface StatusApp {
    start: boolean,
    msg: string,
    reaload: boolean

}

var timeOutIfOffline:any = null;

function Rootview(props: RootViewProps) {
    const [statusApp, setStatusApp] = useState<StatusApp>({ start: false, msg: "Sincronizando dados do servidor...", reaload: true })
    const [showStatusConnexao, setShowStatusConexao] = useState(false)
    const [dbConnected,setDbConnected] = useState(db.dbConnected)
    console.log("db em RootView", db)
    useEffect(() => {
        handleStart()
    }, [])

    const loginFuncionario = () => {
        setStatusApp(state => ({ ...state, msg: "Logando funcionário local..." }))
        let funcString = localStorage.getItem("funcionario")
        if (funcString) {
            let funcObj: Funcionario = JSON.parse(funcString)
            confirmarFuncSelec(funcObj);
        } else {
            props.funcionarioActions.setShowSelectModal(true);
        }
    }

    const confirmarFuncSelec = (func: Funcionario) => {
        props.funcionarioActions.setFuncLogado(func);
        startSincListener()
    }


    const handleStartSync = () => {
        db.startSync({
            dataAmericana: "",
            functionCallbackChange(prms) {
                console.log("callback sync change", prms)
                let findMov = prms.change.docs.find((doc: any) => doc.type === "mov")
                if (findMov !== undefined) {
                    console.log("sync realoadReadView")
                    props.movActions.realoadReadView();
                }
                //atualizar o canal de distribuicao
                let findCanal = prms.change.docs.find((doc: any) => doc.type === "canaldist")
                console.log("findCanal", findCanal)
                if (findCanal !== undefined) {
                    props.canalDistribuicaoActions.readCanalDistAbertos();
                }
            },
            handleCallbackPause(prmState) {
                if (db.statusConexao === "off") {
                    console.log("ligou o statusConnexao")
                    db.setStatusConnexao("on")
                    setShowStatusConexao(true)
                    if(timeOutIfOffline !== null){
                        //desligar o setInterval
                        clearInterval(timeOutIfOffline);
                        timeOutIfOffline = null;
                    }

                }
            },
            handleErrorCallback(error) {
                console.log("desligou o statusConnexao",timeOutIfOffline)
                db.setStatusConnexao("off")
                setShowStatusConexao(true)
                //cancela para tentar novamente apos 1 min.
                db.sync.cancel()
                if(timeOutIfOffline === null)
                    tryConnectIfOffline()
            },
            handleFirstReplicateDone(info) {

            },
        })
    }

    const tryConnectIfOffline = () => {
        timeOutIfOffline = setInterval(() => {
            handleStartSync();
        }, 60000)
    }


    const startSincListener = () => {
        setStatusApp(state => ({ ...state, msg: "Sistema Iniciado", start: true, reaload: false }))
        menuRotas[0].eventOnClick();
        handleStartSync();
    }

    const handleStart = () => {
        db.connected().then(value => {
            console.log("db connected", value)
            if (value.status === "ok") {
                db.replicar("").then(value => {
                    console.log("fim replicacao ", value)
                    props.configActions.startDocConfig();
                    props.tipoMovActions.startDocTipoMov();
                    loginFuncionario()
                })
            } else {
                if(db.dbReplicado()){
                    //se tiver offline mas ja iniciou alguma vez, entao dar continuidade
                    props.configActions.startDocConfig();
                    props.tipoMovActions.startDocTipoMov();
                    loginFuncionario()
                } else {
                    setStatusApp({ start: false, msg: "O sistema precisa estar conectado a internet para a primeira inicialização, detalhes: '" + value.msg + "'", reaload: false })
                }                
            }
        })
    }


    if (statusApp.start && props.funcionarioState.funcLogado._id)
        return (
            <Dashboard menuProps={{
                listItens: menuRotas,
                funcLogado: { nome: props.funcionarioState.funcLogado.nome },
                logout: props.funcionarioActions.logout,
                statusConnection:db.statusConexao,
                dbConnected:dbConnected

            }}>
                <Alerts
                    handleClose={() => props.configActions.setShowAlert(false)}
                    show={props.configState.showAlert}
                    menssage={props.configState.msg}
                    tipoAlerta={props.configState.status === "error" ? "error" : "info"}
                />
                <Alerts
                    handleClose={() => setShowStatusConexao(false)}
                    menssage={db.statusConexao === "off" ? "O sistema esta Offline, desconectado do servidor!" : "O Sistema esta Online, conectado ao Servidor!"}
                    show={showStatusConnexao}
                    tipoAlerta={db.statusConexao === "off" ? "error" : "success"}
                />
                <AninharView />
            </Dashboard>
        )

    return (
        <PageDegrade>
            <Stack
                spacing={2}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    alignItems: 'center',
                    mx: 3,
                    pb: 5,
                    mt: { xs: 8, md: 0 },
                }}
            >
                <Typography textAlign={"center"} variant="h2">{statusApp.msg}</Typography>
                {statusApp.reaload && (
                    <CircularProgress />
                )}
                {!props.funcionarioState.funcLogado._id && statusApp.start && (
                    <Button
                        startIcon={<Login />}
                        onClick={() => props.funcionarioActions.setShowSelectModal(true)}
                    >
                        Logar Funcionario
                    </Button>
                )}
                <SelecionarFuncionario
                    handleConfirmar={(func) => {
                        if (func._id)
                            confirmarFuncSelec(func)
                    }}
                />
            </Stack>


        </PageDegrade>
    )
}

export const mapStateToMeioPagProps = (state: ApplicationState) => ({
    configState: state.configState,
    movState: state.movState,
    tipoMovState: state.tipoMovState,
    funcionarioState: state.funcionarioState,
})

export const mapDispatchToMeioPagProps = (dispatch: Dispatch) => ({
    configActions: bindActionCreators({ ...configController.reducer.actions }, dispatch),
    tipoMovActions: bindActionCreators({ ...tipoMovController.reducer.actions }, dispatch),
    movActions: bindActionCreators({ ...movController.reducer.actions }, dispatch),
    canalDistribuicaoActions: bindActionCreators({ ...canalDistController.reducer.actions }, dispatch),
    funcionarioActions: bindActionCreators({ ...funcionarioController.reducer.actions }, dispatch),
})

export default connect(mapStateToMeioPagProps, mapDispatchToMeioPagProps)(Rootview);